import api from '../../../config/axios-interceptor';

// The admin-only widget configuration is a singleton resource: one GET + one PUT,
// mirroring the backend WidgetSettingsController (/api/v1/widget-settings/**).

export const fetchWidgetSettings = async () => {
    try {
        return await api.get('/api/v1/widget-settings/current');
    } catch (error) {
        console.error('Error fetching widget settings:', error);
        throw error;
    }
};

export const updateWidgetSettings = async (settings) => {
    try {
        return await api.put('/api/v1/widget-settings/update', settings);
    } catch (error) {
        console.error('Error updating widget settings:', error);
        throw error;
    }
};
